<template>

        <div class="flex items-center text-2xl tracking-wider">
            <div class="mr-8 text-2xl">
                {{ slot.start.toCsDayOfWeekString() }},&nbsp;
                {{ slot.start.getDate() }}. {{ slot.start.getMonth() + 1 }}.
            </div>

            <div class="py-6" v-if="readonly">
                {{ slot.start.toCsTimeString() }} - {{ slot.end.toCsTimeString() }}
            </div>

            <div v-else class="flex items-center">
                <TimePicker
                    v-model="slot.start"
                    :max="slot.end"
                    @input="emitChanged()"
                    />
                <span class="mx-2">-</span>
                <TimePicker
                    v-model="slot.end"
                    :min="slot.start"
                    @input="emitChanged()"
                    />
            </div>
        </div>

</template>

<script>
import TimePicker from '@/components/TimePicker';

export default {
    components: {
        TimePicker,
    },

    props: {
        readonly: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            slot: this.$store.slot,
        }
    },

    methods: {
        emitChanged() {
            this.$emit('input');
        }
    }
}
</script>
